import script from "./Repair06Ventilation.vue?vue&type=script&setup=true&lang=js"
export * from "./Repair06Ventilation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__